import { GetState, SetState } from 'zustand';

export interface IFeeData {
  achTransferType: string,
  arrivalDate: string,
  arrivalDateShort: string,
  fee: number,
}

interface IBankTransferFormData {
  accountNumber: string,
  businessName: string,
  routingNumber: string,
  transferAmount: string,
  feeData: IFeeData,
}

export interface IBankTransferSlice {
  accountNumber: string,
  businessName: string,
  routingNumber: string,
  transferAmount: string,
  supplierId: string,
  billId: string,
  chosenAchFee: IFeeData,
  contextType: string,
  setAccountNumber: (accountNumber: string) => void,
  setBusinessName: (businessName: string) => void,
  setRoutingNumber: (routingNumber: string) => void,
  setTransferAmount: (transferAmount: string) => void,
  setSupplierId: (supplierId: string) => void,
  setBillId: (supplierId: string) => void,
  setChosenAchFee: (achFees: IFeeData) => void,
  setContextType: (type: string) => void,
  getBankTransferFormData: () => IBankTransferFormData,
  resetBankTransferSlice: () => void,
}

const bankTransferInitialState = {
  accountNumber: '',
  businessName: '',
  routingNumber: '',
  transferAmount: '',
  supplierId: '',
  billId: '',
  contextType: '',
  chosenAchFee: {
    achTransferType: '',
    arrivalDate: '',
    arrivalDateShort: '',
    fee: 0,
  },
};

const createBankTransferSlice = (set: SetState<IBankTransferSlice>, get: GetState<IBankTransferSlice>) => ({
  accountNumber: '',
  businessName: '',
  routingNumber: '',
  transferAmount: '',
  supplierId: '',
  billId: '',
  contextType: '',
  chosenAchFee: {
    achTransferType: '',
    arrivalDate: '',
    arrivalDateShort: '',
    fee: 0,
  },
  setAccountNumber: (accountNumber: string) => {
    set({
      accountNumber,
    });
  },
  setContextType: (contextType: string) => {
    set({
      contextType,
    });
  },
  setBusinessName: (businessName: string) => {
    set({
      businessName,
    });
  },
  setRoutingNumber: (routingNumber: string) => {
    set({
      routingNumber,
    });
  },
  setTransferAmount: (transferAmount: string) => {
    set({
      transferAmount,
    });
  },
  setSupplierId: (supplierId: string) => {
    set({
      supplierId,
    });
  },
  setBillId: (billId: string) => {
    set({
      billId,
    });
  },
  setChosenAchFee: (chosenAchFee: IFeeData) => {
    set({
      chosenAchFee,
    });
  },
  getBankTransferFormData: () => ({
    accountNumber: get().accountNumber,
    businessName: get().businessName,
    routingNumber: get().routingNumber,
    transferAmount: get().transferAmount,
    feeData: get().chosenAchFee,
  }),
  resetBankTransferSlice: () => {
    set(bankTransferInitialState);
  },
});

export default createBankTransferSlice;
